import isObjectEqual from 'lodash.isequal';

export enum AuditService {
  WARRANTS = 'Warrants',
  CF = 'CFs',
  CF_GROUP = 'CFGroups',
  AF = 'AFs',
  TEAM = 'Teams',
  ROLE = 'Roles',
  USER = 'Users',
  PERIODIC_AUDIT = 'PeriodicAudit',
  DISTRIBUTOR_CONFIGS = 'DistributorConfigs',
  SECURITY_GATEWAY = 'SecurityGateway',
  NETWORK = 'Networks',
  SECURITY_INFO = 'SecurityInfos',
  CERTSTATUS = 'CertStatus',
  CF_FTP_INFO = 'CfFtpInfos',
  DIALED_DIGIT_EXTRACTION_SERVER = 'DialedDigitExtractionServer',
  IRI_BUFFERING = 'IRIBuffering',
  PROCESS_OPTIONS = 'ProcessOptions',
  TARGET_TEMPLATE_PER_ACCESS_FUNCTION = 'TargetTemplatePerAccessFunction',
  UTIMACO_PACKET_SWITCH = 'UtimacoPacketSwitch',
  UTIMACO_CIRCUIT_SWITCH = 'UtimacoCircuitSwitch',
  LOGIN = 'Log In',
  LOGOUT = 'Log Out',
  XDP = 'XDP',
  UPDATE_PASSWORD = 'Update Password',
  TARGET_DOMAIN = 'Target Domain',
  AF_FILTER = 'Access Function Filter',
  FILTER_GROUP = 'Filter Group',
  FILTERS = 'Filters',
  SIP_SETTING = 'SipSetting',
  RADIUS_PARSER_OPTIONS = 'RadiusParserOptions',
  XTP = 'XTP',
  XTP_OPTIONS = 'XTP Options',
  XTP_XDP_CONNECTION = 'Connection between XTP and XDP',
  XTP_XDP_CONNECTION_PROTOCOL = 'Connection Protocol between XTP and XDP',
  RADIUS_PARSER_PASSWORD ='Radius Parser Password',
  KEY_ALARM = 'Key Alarm',
  REGISTERED_NODES = 'REGISTERED_NODES',
  MEDIA_GATEWAY = 'MediaGateways',
  ALARM = 'Alarm',
  ALARM_NOTIFICATION_PROFILE = 'AlarmNotificationProfile',
  AF_WHITELIST = 'AfWhitelist',
  SNMP_USER = 'SNMP User',
  SNMP_DEST = 'SNMP Destination',
  CONTACT = 'Contact',
  SECURITY_POLICY = 'Security Policy',
  CSP_CONFIG = 'CspConfigs',
}

export enum AuditActionType {
  WARRANT_ADD = 'Warrant Add',
  WARRANT_EDIT = 'Warrant Edit',
  WARRANT_DELETE = 'Warrant Delete',
  WARRANT_RESCHEDULE = 'Warrant Reschedule',
  WARRANT_RESTORE = 'Warrant Restore',
  WARRANT_TRASH = 'Warrant Trash',
  WARRANT_STOP = 'Warrant Stop',
  WARRANT_START = 'Warrant Start',
  WARRANT_PAUSE = 'Warrant Pause',
  WARRANT_RESUME = 'Warrant Resume',
  WARRANT_REPROVISION = 'Warrant Reprovision',
  CASE_ADD = 'Case Add',
  CASE_EDIT = 'Case Edit',
  CASE_DELETE = 'Case Delete',
  TARGET_ADD = 'Target Add',
  TARGET_EDIT = 'Target Edit',
  TARGET_DELETE = 'Target Delete',
  ACCESS_FUNCTION_ADD = 'Access Function Add',
  ACCESS_FUNCTION_EDIT = 'Access Function Edit',
  ACCESS_FUNCTION_DELETE = 'Access Function Delete',
  ACCESS_FUNCTION_AUDIT = 'Access Function Audit',
  ACCESS_FUNCTION_REFRESH = 'Access Function Refresh',
  ACCESS_FUNCTION_RESET = 'Access Function Reset',
  IP_ASSIGNMENT_EDIT = 'IP Assignment Edit',
  CF_FTP_INFO_ADD = 'CF FTP Info Add',
  CF_FTP_INFO_EDIT = 'CF FTP Info Edit',
  CF_FTP_INFO_DELETE = 'CF FTP Info Delete',
  COLLECTION_FUNCTION_ADD = 'Collection Function Add',
  COLLECTION_FUNCTION_EDIT = 'Collection Function Edit',
  COLLECTION_FUNCTION_DELETE = 'Collection Function Delete',
  COLLECTION_FUNCTION_GROUP_ADD = 'Collection Function Group Add',
  COLLECTION_FUNCTION_GROUP_EDIT = 'Collection Function Group Edit',
  COLLECTION_FUNCTION_GROUP_DELETE = 'Collection Function Group Delete',
  DISTRIBUTOR_CONFIGURATION_ADD = 'Distributor Configuration Add',
  DISTRIBUTOR_CONFIGURATION_EDIT = 'Distributor Configuration Edit',
  DISTRIBUTOR_CONFIGURATION_DELETE = 'Distributor Configuration Delete',
  VPNCONFIG_ADD = 'VPN Configuration Add',
  VPNCONFIG_EDIT = 'VPN Configuration Edit',
  VPNCONFIG_DELETE = 'VPN Configuration Delete',
  SECURITY_GATEWAY_ADD = 'Security Gateway Add',
  SECURITY_GATEWAY_EDIT = 'Security Gateway Edit',
  SECURITY_GATEWAY_DELETE = 'Security Gateway Delete',
  USER_ADD = 'User Add',
  USER_EDIT = 'User Edit',
  USER_DELETE = 'User Delete',
  ROLE_ADD = 'Role Add',
  ROLE_EDIT = 'Role Edit',
  ROLE_DELETE = 'Role Delete',
  TEAM_ADD = 'Team Add',
  TEAM_EDIT = 'Team Edit',
  TEAM_DELETE = 'Team Delete',
  PERIODIC_AUDIT_EDIT = 'PeriodicAudit Edit',
  NETWORK_ADD = 'Network Add',
  NETWORK_EDIT = 'Network Edit',
  NETWORK_DELETE = 'Network Delete',
  SECURITY_INFO_ADD = 'Security Info Add',
  SECURITY_INFO_EDIT = 'Security Info Edit',
  SECURITY_INFO_DELETE = 'Security Info Delete',
  DIALED_DIGIT_EXTRACTION_SERVER_ADD = 'DialedDigitExtractionServer Add',
  DIALED_DIGIT_EXTRACTION_SERVER_EDIT = 'DialedDigitExtractionServer Edit',
  DIALED_DIGIT_EXTRACTION_SERVER_DELETE = 'DialedDigitExtractionServer Delete',
  DELIVERY_FUNCTION_NETWORK_ADD = 'DeliveryFunctionNetworkInterfaceCreateDialog Add',
  DELIVERY_FUNCTION_NETWORK_EDIT = 'DeliveryFunctionNetworkInterfaceCreateDialog Edit',
  DELIVERY_FUNCTION_NETWORK_DELETE = 'DeliveryFunctionNetworkInterfaceCreateDialog Delete',
  IRI_BUFFERING_EDIT = 'IriBuffering Edit',
  PROCESS_OPTIONS_ADD = 'ProcessOptions Add',
  PROCESS_OPTIONS_EDIT = 'ProcessOptions Edit',
  PROCESS_OPTIONS_DELETE = 'ProcessOptions Delete',
  TARGET_TEMPLATE_PER_ACCESS_FUNCTION_ADD = 'TargetTemplatePerAccessFunction Add',
  TARGET_TEMPLATE_PER_ACCESS_FUNCTION_EDIT = 'TargetTemplatePerAccessFunction Edit',
  TARGET_TEMPLATE_PER_ACCESS_FUNCTION_DELETE = 'TargetTemplatePerAccessFunction Delete',
  UTIMACO_PACKET_SWITCH_ADD = 'UtimacoPacketSwitch Add',
  UTIMACO_PACKET_SWITCH_EDIT = 'UtimacoPacketSwitch Edit',
  UTIMACO_PACKET_SWITCH_DELETE = 'UtimacoPacketSwitch Delete',
  UTIMACO_CIRCUIT_SWITCH_ADD = 'UtimacoPacketSwitch Add',
  UTIMACO_CIRCUIT_SWITCH_DELETE = 'UtimacoPacketSwitch Delete',
  AUTHENTICATE_LOGIN = 'Log In',
  AUTHENTICATE_LOGOUT = 'Log Out',
  XDP_ADD = 'XDP Add',
  XDP_EDIT = 'XDP Edit',
  XDP_DELETE = 'XDP Delete',
  XDP_AUDIT = 'XDP Audit',
  XDP_REFRESH = 'XDP Refresh',
  XDP_RESET = 'XDP Reset',
  UPDATE_PASSWORD = 'Update Password',
  TARGET_DOMAIN_ADD = 'Target Domain Add',
  TARGET_DOMAIN_EDIT = 'Target Domain Edit',
  TARGET_DOMAIN_DELETE = 'Target Domain Delete',
  NAT_CONFIGURATION_ADD = 'NAT Configuration Add',
  NAT_CONFIGURATION_EDIT = 'NAT Configuration Edit',
  JURISDICTION_AREA_ADD = 'Jurisdiction Area Add',
  JURISDICTION_AREA_EDIT = 'Jurisdiction Area Edit',
  JURISDICTION_AREA_DELETE = 'Jurisdiction Area Delete',
  AF_FILTER_ADD = 'Access Function Filter Add',
  AF_FILTER_DELETE = 'Access Function Filter Delete',
  FILTER_GROUP_ADD = 'Filter Group Add',
  FILTER_GROUP_EDIT = 'Filter Group Edit',
  FILTER_GROUP_DELETE = 'Filter Group Delete',
  FILTERS_ADD = 'Filters Add',
  FILTERS_DELETE = 'Filters Delete',
  SIP_SETTING_CREATE = 'SipSetting Create',
  SIP_SETTING_EDIT = 'SipSetting Edit',
  SIP_SETTING_DELETE = 'SipSetting Delete',
  RADIUS_PARSER_OPTIONS_CREATE = 'RadiusParserOptions Create',
  RADIUS_PARSER_OPTIONS_EDIT = 'RadiusParserOptions Edit',
  RADIUS_PARSER_OPTIONS_DELETE = 'RadiusParserOptions Delete',
  XTP_ADD = 'XTP Add',
  XTP_EDIT = 'XTP Edit',
  XTP_DELETE = 'XTP Delete',
  XTP_AUDIT = 'XTP Audit',
  XTP_REFRESH = 'XTP Refresh',
  XTP_RESET = 'XTP Reset',
  XTP_OPTIONS_ADD = 'XTP Options Add',
  XTP_OPTIONS_EDIT = 'XTP Options Edit',
  XTP_OPTIONS_DELETE = 'XTP Options Delete',
  XTP_OPTIONS_AUDIT = 'XTP Options Audit',
  XTP_OPTIONS_REFRESH = 'XTP Options Refresh',
  XTP_OPTIONS_RESET = 'XTP Options Reset',
  XTP_XDP_CONNECTION_ADD = 'Connection between XTP and XDP Add',
  XTP_XDP_CONNECTION_EDIT = 'Connection between XTP and XDP Edit',
  XTP_XDP_CONNECTION_DELETE = 'Connection between XTP and XDP Delete',
  XTP_XDP_CONNECTION_AUDIT = 'Connection between XTP and XDP Audit',
  XTP_XDP_CONNECTION_REFRESH = 'Connection between XTP and XDP Refresh',
  XTP_XDP_CONNECTION_RESET = 'Connection between XTP and XDP Reset',
  XTP_XDP_CONNECTION_PROTOCOL_ADD = 'Connection Protocol between XTP and XDP Add',
  XTP_XDP_CONNECTION_PROTOCOL_EDIT = 'Connection Protocol between XTP and XDP Edit',
  XTP_XDP_CONNECTION_PROTOCOL_DELETE = 'Connection Protocol between XTP and XDP Delete',
  XTP_XDP_CONNECTION_PROTOCOL_AUDIT = 'Connection Protocol between XTP and XDP Audit',
  XTP_XDP_CONNECTION_PROTOCOL_REFRESH = 'Connection Protocol between XTP and XDP Refresh',
  XTP_XDP_CONNECTION_PROTOCOL_RESET = 'Connection Protocol between XTP and XDP Reset',
  RADIUS_PARSER_PASSWORD_CREATE = 'Radius Parser Password Create',
  RADIUS_PARSER_PASSWORD_ADD = 'Radius Parser Password Add',
  RADIUS_PARSER_PASSWORD_EDIT = 'Radius Parser Password Edit',
  RADIUS_PARSER_PASSWORD_DELETE = 'Radius Parser Password Delete',
  RADIUS_PARSER_PASSWORD_AUDIT = 'Radius Parser Password Audit',
  RADIUS_PARSER_PASSWORD_REFRESH = 'Radius Parser Password Refresh',
  RADIUS_PARSER_PASSWORD_RESET = 'Radius Parser Password Reset',
  KEY_ALARM_DELETE = 'Key Alarm Delete',
  REGISTERED_NODES_ADD = 'Registered Nodes Add',
  REGISTERED_NODES_EDIT = 'Registered Nodes Edit',
  REGISTERED_NODES_DELETE = 'Registered Nodes Delete',
  REGISTERED_NODES_AUDIT = 'Registered Nodes Audit',
  REGISTERED_NODES_REFRESH = 'Registered Nodes Refresh',
  REGISTERED_NODES_RESET = 'Registered Nodes Reset',
  MEDIA_GATEWAY_ADD = 'Media Gateway Add',
  MEDIA_GATEWAY_EDIT = 'Media Gateway Edit',
  MEDIA_GATEWAY_DELETE = 'Media Gateway Delete',
  ALARM_SUPPRESS = 'Active Alarm Suppress',
  ALARM_NOTIFICATION_PROFILE_ADD = 'Alarm Notification Profile Add',
  ALARM_NOTIFICATION_PROFILE_EDIT = 'Alarm Notification Profile Edit',
  ALARM_NOTIFICATION_PROFILE_DELETE = 'Alarm Notification Profile Delete',
  CERTSTATUS_ADD = 'Certstatus Add',
  CERTSTATUS_EDIT = 'Certstatus Edit',
  CERTSTATUS_ACTIVATE = 'Certstatus Activate',
  CERTSTATUS_DELETE = 'Certstatus Delete',
  AF_WHITELIST_ADD = 'AfWhitelist Add',
  AF_WHITELIST_EDIT = 'AfWhitelist Edit',
  AF_WHITELIST_DELETE = 'AfWhitelist Delete',
  SNMP_USER_ADD = 'SNMP User Add',
  SNMP_USER_EDIT = 'SNMP User Edit',
  SNMP_USER_DELETE = 'SNMP User Delete',
  SNMP_DEST_ADD = 'SNMP Dest Add',
  SNMP_DEST_EDIT = 'SNMP Dest Edit',
  SNMP_DEST_DELETE = 'SNMP Dest Delete',
  CONTACT_ADD = 'Contact Add',
  CONTACT_EDIT = 'Contact Edit',
  CONTACT_DELETE = 'Contact Delete',
  SECURITY_POLICY_ADD = 'Security Policy Add',
  SECURITY_POLICY_EDIT = 'Security Policy Edit',
  CSP_CONFIG_ADD = 'CspConfig Add',
  CSP_CONFIG_EDIT = 'CspConfig Edit',
  CSP_CONFIG_DELETE = 'CspConfig Delete',
}

export const getAuditFieldInfo = (formData: any, auditData: any = null, isEdit = false,
  beforeFieldValues: any = null) => {
  const fieldInfo: any = [];
  if (formData) {
    Object.keys(formData).forEach((key: any) => {
      if (isEdit) {
        const beforeValue = beforeFieldValues?.[key];
        if (!isObjectEqual(beforeValue, formData[key])) {
          fieldInfo.push({
            field: key,
            before: beforeValue ?? '',
            after: formData[key],
          });
        }
      } else {
        fieldInfo.push({ field: key, value: formData[key] });
      }
    });
  }

  if (auditData) {
    Object.keys(auditData).forEach((key: any) => {
      fieldInfo.push({
        field: key,
        value: auditData[key],
      });
    });
  }
  return fieldInfo;
};

export const getAuditDetails = (auditEnabled: boolean, userId: string, userName: string,
  userAudit: any, recordName: string, service: string, actionType: string) => {
  return {
    auditEnabled,
    userId,
    userName,
    fieldDetails: JSON.stringify(userAudit),
    recordName,
    service,
    actionType,
  };
};
